import React from 'react';

import { Box } from '@/components/lib/components';

export const EmptyOptionButton = (props: React.ComponentProps<typeof Box>) => {
    return <Box borderRadius="r10" height={56} flex={1} borderColor="gray7" borderWidth={1} {...props} />;
};
